import { createContext, useContext } from 'react';

export interface QueryEditorState {
  value: string;
  onChange: (value: string) => void;
  onRun?: () => void;
  /** Active mode when using ModeToggle / ModeContent (controlled by the consumer via Root). */
  mode?: string;
  onModeChange?: (mode: string) => void;
}

const QueryEditorContext = createContext<QueryEditorState | null>(null);

export const QueryEditorContextProvider = QueryEditorContext.Provider;

/**
 * Access state from the nearest QueryEditor.Root.
 * Throws if used outside a QueryEditor.Root.
 */
export function useQueryEditorContext(): QueryEditorState {
  const ctx = useContext(QueryEditorContext);
  if (ctx === null) {
    throw new Error('QueryEditor compound components must be rendered inside a <QueryEditor.Root>.');
  }
  return ctx;
}
